import { render, staticRenderFns } from "./tabLclContainer.vue?vue&type=template&id=386aa859&scoped=true&"
import script from "./tabLclContainer.vue?vue&type=script&lang=js&"
export * from "./tabLclContainer.vue?vue&type=script&lang=js&"
import style0 from "./tabLclContainer.vue?vue&type=style&index=0&id=386aa859&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386aa859",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386aa859')) {
      api.createRecord('386aa859', component.options)
    } else {
      api.reload('386aa859', component.options)
    }
    module.hot.accept("./tabLclContainer.vue?vue&type=template&id=386aa859&scoped=true&", function () {
      api.rerender('386aa859', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/RailwayExport/components/booking/tabs/tabLclContainer.vue"
export default component.exports